// Mock data for trending charms
export const trendingCharms = [
  {
    id: 1,
    name: "Heart Lock Charm",
    image: "https://images.unsplash.com/photo-1749672197593-5682fde3702f",
    avgPrice: 45.99,
    priceChange: 12.5,
    material: "Silver",
    status: "Active"
  },
  {
    id: 2,
    name: "Birthstone Dangle",
    image: "https://images.unsplash.com/photo-1749672327818-2bf0797689dd",
    avgPrice: 78.50,
    priceChange: -3.2,
    material: "Mixed",
    status: "Retired"
  },
  {
    id: 3,
    name: "Texas State Charm",
    image: "https://images.unsplash.com/photo-1749672327814-f5eadb278229",
    avgPrice: 52.00,
    priceChange: 8.7,
    material: "Silver",
    status: "Active"
  },
  {
    id: 4,
    name: "Cross with Stones",
    image: "https://images.unsplash.com/photo-1758911995794-3eabd996bd3d",
    avgPrice: 125.00,
    priceChange: 15.3,
    material: "Gold",
    status: "Retired"
  },
  {
    id: 5,
    name: "Angel Wings Charm",
    image: "https://images.unsplash.com/photo-1731531534571-91c2a59148d3",
    avgPrice: 38.75,
    priceChange: 5.1,
    material: "Silver",
    status: "Active"
  },
  {
    id: 6,
    name: "Peacock Detailed Charm",
    image: "https://images.unsplash.com/photo-1713004539634-a6694a83f3d9",
    avgPrice: 92.00,
    priceChange: 22.8,
    material: "Silver",
    status: "Retired"
  }
];

// Mock data for how it works features
export const features = [
  {
    icon: "TrendingUp",
    title: "Accurate Price History",
    description: "See historical highs, lows, and averages across multiple marketplaces."
  },
  {
    icon: "Search",
    title: "Live Listings",
    description: "Browse active sales across eBay, Poshmark, Etsy, and more platforms."
  },
  {
    icon: "Clock",
    title: "Retired Status",
    description: "Instantly know if a charm is still sold by James Avery or retired."
  },
  {
    icon: "Activity",
    title: "Popularity Tracking",
    description: "Discover what collectors are buying and watching right now."
  }
];

// Mock data for why collectors section
export const collectorReasons = [
  {
    icon: "Brain",
    title: "Real-World Pricing Data",
    description: "Aggregated from actual sales, not inflated asking prices."
  },
  {
    icon: "Zap",
    title: "Instant Market Updates",
    description: "Refreshed every few hours to keep you ahead of trends."
  },
  {
    icon: "Gem",
    title: "Designed for Collectors",
    description: "Clean interface focused on what matters most to you."
  }
];